module.exports = __webpack_public_path__ + "static/media/0222_IMG_LES_MURS_P21_UNI_CRISTAL_CHEVRON.2f400c42.png";